<template>
  <div>
    <div style="cursor: pointer;margin-bottom: 16px;color: #fff;" @click="back">
      <a-icon type="left" style="margin-right: 2px" />
      <span>返回</span>
    </div>

    <a-form
      :label-col="{ span: 8 }"
      :wrapper-col="{ span: 14 }"
      :colon="false"
      :form="form"
      @submit="handleSubmit"
    >
      <a-row>
        <a-col :lg="12" :md="12" :sm="24">
            <InputField style="width: 90%; margin: 0.5rem auto" label="编号" type="text" id="code"
                        :modelValue="form.code" placeholder="请输入编号" required
                        @update:modelValue="(value) => handleModelValueUpdate('code', value)"
            />
        </a-col>

        <a-col :lg="12" :md="12" :sm="24">
            <SelectField style="width: 90%; margin: 0.5rem auto" label="管网类型" id="type"
                         :modelValue="form.category" :options="pipeTypeList"
                         required labelWidth="40%"  :disabled = "view === '修改管网'"
                         @update:modelValue="(value) => handleModelValueUpdate('category', value)"
            />
        </a-col>
      </a-row>
      <a-row>
        <a-col :lg="12" :md="12" :sm="24">
            <InputField style="width: 90%; margin: 0.5rem auto" label="起点位置" type="text" id="startLnglat" :disabled = "view === '修改管网'"
                        :modelValue="form.startLnglat" placeholder="请输入起点位置"
                        inputImg required @img-click="pasteLnglat('start')"
                        @update:modelValue="(value) => handleModelValueUpdate('startLnglat', value)"
            />
        </a-col>

        <a-col :lg="12" :md="12" :sm="24">
            <InputField style="width: 90%; margin: 0.5rem auto" label="起点井" type="text" id="pointFrom" :disabled = "view === '修改管网'"
                        :modelValue="form.pointFrom" placeholder="请输入起点井"
                        inputImg  @img-click="pasteWell('start')"
                        @update:modelValue="(value) => handleModelValueUpdate('pointFrom', value)"
            />
        </a-col>

        <a-col :lg="12" :md="12" :sm="24">

            <InputField style="width: 90%; margin: 0.5rem auto" label="终点位置" type="text" id="endLnglat" :disabled = "view === '修改管网'"
                        :modelValue="form.endLnglat" placeholder="请输入终点位置"
                        inputImg required="" @img-click="pasteLnglat('end')"
                        @update:modelValue="(value) => handleModelValueUpdate('endLnglat', value)"
            />
        </a-col>

        <a-col :lg="12" :md="12" :sm="24">
            <InputField style="width: 90%; margin: 0.5rem auto" label="终点井" type="text" id="pointTo" :disabled = "view === '修改管网'"
                        :modelValue="form.pointTo" placeholder="请输入终点井"
                        inputImg @img-click="pasteWell('end')"
                        @update:modelValue="(value) => handleModelValueUpdate('pointTo', value)"
            />
        </a-col>

        <a-col :lg="12" :md="12" :sm="24">
            <InputField style="width: 90%;margin:0.5rem auto" label="起点高程(m)" type="number" id="elevationFrom"
                        :modelValue="form.elevationFrom" placeholder="请输入起点高程(m)"
                        @update:modelValue="(value) => handleModelValueUpdate('elevationFrom', value)"
            />
        </a-col>

        <a-col :lg="12" :md="12" :sm="24">
            <InputField style="width: 90%;margin:0.5rem auto" label="终点高程(m)" type="number" id="elevationTo"
                        :modelValue="form.elevationTo" placeholder="请输入终点高程(m)"
                        @update:modelValue="(value) => handleModelValueUpdate('elevationTo', value)"
            />
        </a-col>

        <a-col :lg="12" :md="12" :sm="24">
            <InputField style="width: 90%;margin:0.5rem auto" label="起点埋深(m)" type="number" id="buringDepthFrom"
                        :modelValue="form.buringDepthFrom" placeholder="请输入起点埋深(m)"
                        @update:modelValue="(value) => handleModelValueUpdate('buringDepthFrom', value)"
            />
        </a-col>

        <a-col :lg="12" :md="12" :sm="24">
            <InputField style="width: 90%;margin:0.5rem auto" label="终点埋深(m)" type="number" id="buringDepthTo"
                        :modelValue="form.buringDepthTo" placeholder="请输入终点埋深(m)"
                        @update:modelValue="(value) => handleModelValueUpdate('buringDepthTo', value)"
            />
        </a-col>

        <a-col :lg="12" :md="12" :sm="24">
            <InputField style="width: 90%;margin:0.5rem auto" label="管长(m)" type="number" id="length"
                        :modelValue="form.length" placeholder="请输入管长(m)"
                        @update:modelValue="(value) => handleModelValueUpdate('length', value)"
            />
        </a-col>

        <a-col :lg="12" :md="12" :sm="24">
            <InputField style="width: 90%;margin:0.5rem auto" label="管径(mm)" type="number" id="diameter"
                        :modelValue="form.diameter" placeholder="请输入管径(mm)"
                        @update:modelValue="(value) => handleModelValueUpdate('diameter', value)"
            />
        </a-col>

        <a-col :lg="12" :md="12" :sm="24">
            <InputField style="width: 90%;margin:0.5rem auto" label="材质" type="text" id="material"
                        :modelValue="form.material" placeholder="请输入材质"
                        @update:modelValue="(value) => handleModelValueUpdate('material', value)"
            />
        </a-col>

        <a-col :lg="12" :md="12" :sm="24">
            <InputField style="width: 90%;margin:0.5rem auto" label="所在道路" type="text" id="location"
                        :modelValue="form.location" placeholder="请输入所在道路"
                        @update:modelValue="(value) => handleModelValueUpdate('location', value)"
            />
        </a-col>
      </a-row>

      <div class="center" style="margin-top: 10px;">
        <a-space>
            <ButtonField text="取消" @click="back" secondary/>
            <ButtonField text="保存" primary @click="handleSubmit"/>
            <ButtonField text="管线转向" @click="transfer" secondary/>
        </a-space>
      </div>
    </a-form>
  </div>
</template>
<script>
import store from "../mixins/store";
import { mapGetters } from "vuex";

import { add, edit, fetchDetail } from "@/api/assets/pipe.js";
import { fetchDetail as fetchWellDetail } from "@/api/assets/inspectWell";
import InputField from "@/components/water-affairs-style/field/InputField.vue";
import ButtonField from "@/components/water-affairs-style/field/ButtonField.vue";
import SelectField from "@/components/water-affairs-style/field/SelectField.vue";
export default {
  mixins: [store],
  components: {
      InputField,ButtonField,SelectField
  },
  data() {
    return {
      detail: {},
      form: {
          code: '',
          category: '',
          startLnglat: '',
          endLnglat: '',
          pointFrom: '',
          pointTo: '',
          elevationFrom: null,
          elevationTo: null,
          buringDepthFrom: null,
          buringDepthTo: null,
          length: null,
          diameter: null,
          material: '',
          location: '',
      },
      saveLoading: false,
    };
  },
  computed: {
    ...mapGetters("setting", ["findDataDict"]),
    pipeTypeList() {
      return this.findDataDict("pipeType");
    },
  },

  watch: {
    selectedPipe: {
      handler() {
        if (this.view === "修改管网" && this.selectedPipe._edit) {
          this.getDetail();
        }
      },
      deep: true,
    },
  },
  mounted() {
      this.$nextTick(() => {
          if (this.view === "修改管网" && this.selectedPipe._edit) {
              this.getDetail();
          }
      });
  },
  methods: {
    handleModelValueUpdate(fieldName, value) {
        this.form[fieldName] = value;
    },
    getDetail() {
        this.form = {
            code: '',
            category: '',
            startLnglat: '',
            endLnglat: '',
            pointFrom: '',
            pointTo: '',
            elevationFrom: null,
            elevationTo: null,
            buringDepthFrom: null,
            buringDepthTo: null,
            length: null,
            diameter: null,
            material: '',
            location: '',
        }
      this.detail = {};

      const hide = this.$message.loading("加载中...", 0);
      fetchDetail({
        id: this.selectedPipe.id,
        category: this.selectedPipe.type,
      })
        .then((res) => {
          console.log("pipe detail", res);
          if (!res) return;
          this.detail = res;
          this.form.code = res.code;
          this.form.category = res.category;
          this.form.buringDepthFrom = res.buringDepthFrom;
          this.form.buringDepthTo = res.buringDepthTo;
          this.form.diameter = res.diameter;
          this.form.elevationFrom = res.elevationFrom;
          this.form.elevationTo = res.elevationTo;
          this.form.length = res.length;
          this.form.location = res.location;
          this.form.material = res.material;
          this.form.startLnglat = res.xfrom + "," + res.yfrom;
          this.form.endLnglat = res.xto + "," + res.yto;
          this.form.pointFrom = res.pointFrom;
          this.form.pointTo = res.pointTo;

          console.log(" this.form:::", this.form)
        })
        .finally(() => {
          hide();
        });
    },
    pasteLnglat(type) {

      if (!this.selectedLnglat || !this.selectedLnglat.lng || !this.selectedLnglat.lat) {
          this.$message.error("请点击地图选择经纬度");
          return;
      }
      const { lng, lat } = this.selectedLnglat;
      const value = lng + "," + lat;
      if (type === "start") {
          this.form.startLnglat = value
      } else {
        this.form.endLnglat = value
      }
    },

    pasteWell(type) {
      const { name, id, x, y } = this.selectedWell;

      if (name !== "污水检查井" && name !== "雨水检查井") {
        this.$message.error("请选择检查井");
        return;
      }

      const category = this.form.getFieldValue("category");

      if (!category) {
        this.$message.error("请选择管网类型");
        return;
      }

      if (name === "污水检查井" && category !== "sewage") {
        this.$message.error("请选择雨水检查井");
        return;
      }
      if (name === "雨水检查井" && category !== "rain") {
        this.$message.error("请选择污水检查井");
        return;
      }

      fetchWellDetail({
        category,
        id,
      }).then((res) => {
        const code = res ? res.code : "";

        if (type === "start") {
            this.form.pointFrom = code
            this.form.startLnglat = x + "," + y
        } else {
            this.form.pointTo = code
            this.form.endLnglat = x + "," + y
        }
      });
    },

    transfer() {
      const startLnglat = this.form.startLnglat;
      const endLnglat = this.form.endLnglat;
      const pointFrom = this.form.pointFrom;
      const pointTo = this.form.pointTo;

      this.form.setFieldsValue({
        startLnglat: endLnglat,
        endLnglat: startLnglat,
        pointFrom: pointTo,
        pointTo: pointFrom,
      });
    },

    handleSubmit() {
        if (this.isSubmitting) return;
        this.isSubmitting = true;
        if (!this.form.code) {
            this.$message.error('编号不能为空');
            this.isSubmitting = false;
            return;
        }
        if (!this.form.category) {
            this.$message.error('管网类型不能为空');
            this.isSubmitting = false;
            return;
        }
        if (!this.form.startLnglat) {
            this.$message.error('起点位置不能为空');
            this.isSubmitting = false;
            return;
        }
        if (!this.form.endLnglat) {
            this.$message.error('终点位置不能为空');
            this.isSubmitting = false;
            return;
        }
        const startArr = this.form.startLnglat.split(",");
        const endArr = this.form.endLnglat.split(",");

        const xfrom = parseFloat(startArr[0]);
        const yfrom = parseFloat(startArr[1]);
        const xto = parseFloat(endArr[0]);
        const yto = parseFloat(endArr[1]);

        if (isNaN(xfrom) || isNaN(yfrom) || isNaN(xto) || isNaN(yto)) {
            this.$message.error("起点或终点经纬度无效");
            return;
        }

      let params = {
        id: this.detail.id,
        ...this.form,

        xfrom,
        yfrom,
        xto,
        yto,
      };
      this.saveLoading = true;

      let task = add;
      if (this.detail.id) {
        task = edit;
      }
      task(params)
        .then(() => {
          if (this.form.category === "sewage") {
            this.getSewagePipeList();
          } else {
            this.getRainPipeList();
          }
          this.back();
        })
        .finally(() => {
          this.saveLoading = false;
        });
    },

      back() {
          this.form = {
              code: '',
              category: '',
              startLnglat: '',
              endLnglat: '',
              pointFrom: '',
              pointTo: '',
              elevationFrom: null,
              elevationTo: null,
              buringDepthFrom: null,
              buringDepthTo: null,
              length: null,
              diameter: null,
              material: '',
              location: '',
          };

          this.setSelectedLnglat({});
          this.setSelectedWell({});
          this.setSelectedPipe({});

          this.setView("管网");
      },
  },
};
</script>

<style lang="less" scoped>
.location {
  display: block;
  height: auto;
  width: 12px;
}

.center {
  padding-bottom: 24px;
}
</style>